@if (showLoader) {
  <div class="loading-indicator">
    <app-loader></app-loader>
  </div>
}
<div class="container{{ isDemoMode ? ' demo' : '' }}">
  <router-outlet></router-outlet>
</div>
